/**
 * Check if the browser is IE11
 */

export function normalizeString (str) {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z ]/g, '')
}
